<div class="row fuelux">
	<!-- Form -->
	<div [ngClass]="{'col-xs-5': showUpload, 'col-xs-7': !showUpload}">
		<div class="col-xs-12" *ngIf="!share">
			<div class="form-group">
				<label for="note" class="control-label">
					Internal Notes:
				</label>
				<!-- Voice Input -->
				<div class="mb-2">
					<app-voice-input
						(transcriptReady)="onVoiceTranscript($event)"
						[candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
						[company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
						[requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
						[jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null"
						[sourceScreen]="sourceScreen">
					</app-voice-input>
				</div>
				<textarea id="note" name="note" class="form-control" rows="3"
					placeholder="Enter your note.." [(ngModel)]="document.internalNote"
				></textarea>
				<!-- Formalize Text -->
				<app-formalize-comment
					[inputText]="document.internalNote"
					(outputText)="receiveFormalizedComment($event)"
					[candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
					[company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
					[requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
					[jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null"
					[sourceScreen]="sourceScreen">
				</app-formalize-comment>
			</div>
		</div>
		<div class="col-xs-12" *ngIf="!share && !hideShare">
			<div class="checkbox-nice">
				<input type="checkbox" [(ngModel)]="document.shared" id="shared" name="shared">
				<label for="shared">Share Externally</label>
			</div>
		</div>

		<div class="col-xs-12" *ngIf="document.shared && !hideShare">
			<!-- Shared With dropdown -->
			<div class="form-group mt-3" [ngClass]="{'has-error': uploadClicked && (document.shared && selectedCompaniesToShare.length === 0)}">
				<label for="sharedWith" class="control-label">Document Shared With : </label>
				<ng-select name="sharedWith" id="sharedWith" [items]="companiesToShare" bindLabel="name"
					[(ngModel)]="selectedCompaniesToShare" [multiple]="true" [closeOnSelect]="false"
					placeholder="Select companies" style="width: 75%;"
					(change)="onCompanyToShareSelected()" (close)="onCompanyToShareSelected()">
					<ng-template ng-header-tmp>
						<div class="d-flex">
							<div class="mr-2 custom-ng-select-btn" (click)="selectAllCompaniesToShare()">All</div>
							<div class="custom-ng-select-btn" (click)="removeAllSelectedCompanies()">None</div>
						</div>
					</ng-template>
				</ng-select>
			</div>
		</div>
	</div>

	<!-- Wizard -->
	<div class="col-xs-7" [hidden]="!showUpload || share">
		<div class="main-box clearfix" style="min-height: 200px;">
			<div class="main-box-body clearfix col-lg-10 col-lg-offset-1 mt-5">
				<div>
					<form name="documentUploadDropzone" id="documentUploadDropzone" class="dropzone dz-clickable" action="" enctype="multipart/form-data"
						[dropzone]="dropzoneConfig" (addedFile)="onFileAdded()" (removedFile)="onFileRemoved()"
						(sendingMultiple)="onFileSendingMultiple($event)" (successMultiple)="onFileSuccessMultiple($event)"
						(error)="onFileError($event)">
						<div class="dz-a dz-default dz-message text-center">
							<span>
								<h3>Drop file here to upload</h3>(or click)
							</span>
						</div>
					</form>
				</div>
			</div>
			<!-- Upload Document button -->
			<div class="row buttonrow" style="margin-bottom: 200px">
				<div class="col-xs-12 col-sm-offset-4 col-sm-4">
					<button type="button" class="btn btn-success col-xs-12 p-2" id="uploadFile"
						(click)="uploadDocument()">
						<i class="fa fa-upload mr-2"></i>
						<span *ngIf="!fileUploadInProgressFlag">
							<span *ngIf="!isEdit">Upload Document</span>
							<span *ngIf="isEdit">Upload New Version</span>
						</span>
						<span *ngIf="fileUploadInProgressFlag">Uploading...</span>
					</button>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="!showUpload" class="col-xs-12 text-right">
		<div class="clearfix">
			<button type="button" class="btn btn-danger mr-2" (click)="cancelCallback.emit()" [disabled]="savingFlag || fileUploadInProgressFlag">
				<span>Cancel</span>
			</button>
			<button type="submit" class="btn btn-success" (click)="updateDocumentData()" [disabled]="savingFlag || fileUploadInProgressFlag">
				<span *ngIf="!savingFlag">
					Save
				</span>
				<span *ngIf="savingFlag">Updating..</span>
			</button>
		</div>
	</div>
</div>
